module.exports = __webpack_public_path__ + "src/img/previewCloseIcon.abdbd88f.png";